export class Shutter {

    public timeDiffCorrection:boolean = true;
    public curveCorrection:boolean = true;
    public slitCorrection:boolean = true;
    
    contructor(){

    } 
} 